/**
 * AI 타임아웃 관리 API — 동적(즉시) + env(재시작 안내).
 * admin BFF /api/admin/ai-timeouts/*.
 */
import { apiClient } from './client';

export interface DynamicTimeout { key: string; label: string; default_ms: number; desc: string; value_ms: number }
export interface EnvTimeout {
  key: string; service: string; label: string; default_ms: number; desc: string;
  current_ms: number | null; effective_ms: number; restart_service: string;
}

export async function listAiTimeouts(): Promise<{ dynamic: DynamicTimeout[]; env: EnvTimeout[] }> {
  const { data } = await apiClient.get<{ dynamic: DynamicTimeout[]; env: EnvTimeout[] }>('/admin/ai-timeouts');
  // 방어 가드(additive) — dynamic/env 가 배열이 아닌 비정형 응답에도 소비처 map 크래시 차단.
  return {
    dynamic: Array.isArray(data?.dynamic) ? data.dynamic : [],
    env: Array.isArray(data?.env) ? data.env : [],
  };
}
export async function setDynamicTimeout(key: string, value_ms: number): Promise<void> {
  await apiClient.put('/admin/ai-timeouts/dynamic', { key, value_ms });
}
export async function setEnvTimeout(key: string, value_ms: number): Promise<{ ok: boolean; service: string; restart_service: string }> {
  const { data } = await apiClient.put<{ ok: boolean; service: string; restart_service: string }>('/admin/ai-timeouts/env', { key, value_ms });
  return data;
}
